import * as TYPE from './types';
import { apiAction } from '../../api/actions';

export function getFlowTypes(params) {
  return apiAction({
    resource: '/su/flow-type',
    params,
    onSuccess: (data) => onGetSuccess(data),
    onFailure: (error) => onGetFailed(error),
    carry: {
      label: TYPE.GET_FLOW_TYPES
    },
  });
};

function onGetSuccess(data) {
  return {
    type: TYPE.GET_FLOW_TYPES_SUCCESS,
    payload: data,
  };
};

function onGetFailed(error) {
  return {
    type: TYPE.GET_FLOW_TYPES_FAILED,
    payload: {
      error
    }
  };
};